export default __webpack_public_path__ + "0b6472f3527406ec0732381c76d0c65a.png";